import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

//import LoanOfficerLanding from "./components/LoanOfficerLanding";
import LoLanding from "./components/LoLanding";
import "./fonts.css"; // Import the CSS file
import RouteLogger from "./RouteLogger";
const App = () => {
  // let router = [
  //   { path: "/index.html", Element: <LoanOfficerLanding /> },
  //   { path: "/R", Element: <LoanOfficerLanding /> },
  //   { path: "/R*", Element: <LoanOfficerLanding /> },
  //   { path: "/R/*", Element: <LoanOfficerLanding /> },
  //   { path: "/LoanOfficerWebsite/index.html", Element: <LoanOfficerLanding /> },
  //   { path: "/localhost:3000/index.html", Element: <LoanOfficerLanding /> },
  // ];

  useEffect(() => {
    const redirectToSecureWWW = () => {
      const currentURL = window.location.href;
      if (!currentURL.includes("localhost")) {
        // Check if "https" is missing or "www" is missing
        if (
          !currentURL.includes("https://") ||
          !currentURL.includes("www.") ||
          currentURL.includes("directcorp")
        ) {
          // Redirect to the secured and www version of the URL
          let hostname = window.location.hostname;
          if (currentURL.includes("directcorp")) {
            hostname = hostname.replace("directcorp", "directmortgage");
          }

          const queryString = window.location.search;

          if (!currentURL.includes("www."))
            window.location.href = `https://www.${hostname}${window.location.pathname}${queryString}`;
          else
            window.location.href = `https://${hostname}${window.location.pathname}${queryString}`;
        }
      }
    };

    // Perform the initial check when the component mounts
    redirectToSecureWWW();
  }, []);

  let router = [
    { path: "/", Element: <LoLanding /> },
    { path: "/index.html", Element: <LoLanding /> },
    { path: "/R", Element: <LoLanding /> },
    { path: "/R*", Element: <LoLanding /> },
    { path: "/R/*", Element: <LoLanding /> },
    { path: "/LoanOfficerWebsite/index.html", Element: <LoLanding /> },
    { path: "/localhost:3000/index.html", Element: <LoLanding /> },
    { path: "/*", Element: <LoLanding /> },
    { path: "*", Element: <LoLanding /> },
  ];

  if (window.location.href.indexOf("localhost:3000") > -1) {
    router.forEach(
      (item) => (item.path = item.path.replace("/LoanOfficerWebsite", ""))
    );
  }
  return (
    
    <BrowserRouter>
      <RouteLogger />
      <Routes>
        {router.map((item, index) => (
          <Route path={item.path} key={index} element={item.Element} />
        ))}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
